import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';
import { black, blue, grey40 } from 'Styles/colors';
import { NotificationBody } from '../../../Notification/Notification';

export const SignUpLink = styled.button`
  ${fontTitle(14)};
  color: ${blue};
  text-decoration: underline;
  background: none;
  border: 0;
  cursor: pointer;
`;

export const TextLink = styled.button`
  ${fontBody(14)};
  color: ${black};
  text-decoration: underline;
  background: none;
  border: 0;
  text-align: left;
  padding: 0;
  cursor: pointer;
`;

export const FormWrap = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const SignUpText = styled.p`
  ${fontBody(14)};
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid ${grey40};
  text-align: center;
`;

export const OrText = styled.p`
  ${fontBody(14)};
  margin: 8px 0;
  text-align: center;
`;

export const DescriptionText = styled.p`
  ${fontBody(16)};
  text-align: center;
`;

export const Bold = styled.span`
  font-weight: 800;
`;

export const LoginForm = styled.div``;

export const NotificationError = styled(NotificationBody)`
  display: block;
  width: 100%;
  border-radius: 4px;
`;
